/*
 * View for the move topics/contents modal, containing a nav tree to move content or topics
 * to a new folder
 */

define(["marionette", "modules/shared/moveModal/template/moveModalTemplate.html"], function (
  Marionette,
  MoveModalTemplate,
) {
  var MoveModalView = {};

  MoveModalView.moveModalLayout = Marionette.Layout.extend({
    template: MoveModalTemplate,
    regions: {
      moveTree: "#moveTree",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    clearError: function () {
      this.$el.find("#moveError").html("");
    },
    moveError: function (errorMessage) {
      this.$el
        .find("#moveError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return MoveModalView;
});
